// removed by extract-text-webpack-plugin
module.exports = {"separator":"separator___23bD-","small":"small___1IUN5","medium":"medium___1LEl3","brand":"brand___2euly","wrong":"wrong___IaMXX","primary":"primary___3jTMQ","negative":"negative___2LbWU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Separator/index.scss
// module id = 106
// module chunks = 0